export enum SearchFieldAll {
  ALL = 'ALL',
}

export enum SearchFieldType {
  TextField = 'TextField',
  SelectField = 'SelectField',
  DateRange = 'DateRange',
}
